"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.HashQueryStringUtils = exports.NoHashQueryStringUtils = void 0;
var appauth_1 = require("@openid/appauth");
var NoHashQueryStringUtils = /** @class */ (function (_super) {
    __extends(NoHashQueryStringUtils, _super);
    function NoHashQueryStringUtils() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NoHashQueryStringUtils.prototype.parse = function (input, useHash) {
        var output = _super.prototype.parse.call(this, input, false /* never use hash */);
        return output;
    };
    return NoHashQueryStringUtils;
}(appauth_1.BasicQueryStringUtils));
exports.NoHashQueryStringUtils = NoHashQueryStringUtils;
var keys = ["code", "session_state", "state"];
var HashQueryStringUtils = /** @class */ (function (_super) {
    __extends(HashQueryStringUtils, _super);
    function HashQueryStringUtils() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HashQueryStringUtils.prototype.parse = function (input, useHash) {
        var output = _super.prototype.parse.call(this, input, true /* use hash */);
        // Fix AppAuthJs behavior
        var propertyToDelelete = null;
        Object.entries(output).map(function (_a) {
            var key = _a[0], value = _a[1];
            keys.forEach(function (k) {
                if (key.endsWith("?".concat(k))) {
                    output[k] = value;
                    propertyToDelelete = key;
                }
            });
        });
        if (propertyToDelelete) {
            delete output[propertyToDelelete];
        }
        return output;
    };
    return HashQueryStringUtils;
}(appauth_1.BasicQueryStringUtils));
exports.HashQueryStringUtils = HashQueryStringUtils;
//# sourceMappingURL=noHashQueryStringUtils.js.map